let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("j4POW"), load("ffEVr"), load("3XMOA"), load("4uUio")]).then(() => parcelRequire('ayZRr'));